import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import CallFAB from "@/components/CallFAB";
import ChatBot from "@/components/ChatBot";
import OffersRibbon from "@/components/OffersRibbon";
import Hero from "@/components/Hero";
import CurrentRate from "@/components/CurrentRate";
import WhyDivyaDhara from "@/components/WhyDivyaDhara";
import WhyGIRMilk from "@/components/WhyGIRMilk";
import Founders from "@/components/Founders";
import CowInfographic from "@/components/CowInfographic";
import PincodeChecker from "@/components/PincodeChecker";
import SubscriptionPlans from "@/components/SubscriptionPlans";
import HowItWorks from "@/components/HowItWorks";
import PurityPromise from "@/components/PurityPromise";
import SeeTheDifference from "@/components/SeeTheDifference";
import Testimonials from "@/components/Testimonials";
import LimitedTimeOffer from "@/components/LimitedTimeOffer";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import UpiPayment from "@/components/UpiPayment";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [hash]);

  return (
    <div className="bg-dd-page" data-testid="home-page">
      <Navbar />
      <OffersRibbon />
      <main>
        <Hero />
        <CurrentRate />
        <WhyDivyaDhara />
        <WhyGIRMilk />
        <Founders />
        <CowInfographic />
        <PincodeChecker />
        <SubscriptionPlans />
        <UpiPayment />
        <HowItWorks />
        <PurityPromise />
        <SeeTheDifference />
        <Testimonials />
        <LimitedTimeOffer />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFAB />
      <CallFAB />
      <ChatBot />
    </div>
  );
}
